<dt ng-if="object.descricao.length <= 25">
  Entre nós atacados:
</dt>
<dd>{{object.summarize.percentual | number:2}}%</dd>